import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container privacy-policy-page">
          <div className="section-header">
            <span className="section-badge">Legal</span>
            <h1 className="section-title">Privacy Policy for Ygalaad</h1>
            <p className="section-description privacy-policy-meta">
              <strong>Effective Date:</strong> 16/07/2025
            </p>
          </div>

          <div className="privacy-policy-content">
            <p>
              This Privacy Policy explains how Ygalaad ("we", "us", "our")
              collects, uses, and discloses information when you use our mobile
              application, Master Sudoku Challenge (the "App").
            </p>

            <h2>1. Information We Collect</h2>
            <p>We may collect the following types of information when you use the App:</p>
            <ul>
              <li>
                <strong>Personal Information:</strong> We do not collect personal
                information such as your name, email address, or phone number
                unless you voluntarily provide it (e.g., via customer support
                requests).
              </li>
              <li>
                <strong>Usage Data:</strong> We collect anonymous usage data,
                including in-game statistics and interactions with the App, to
                help us improve the user experience.
              </li>
              <li>
                <strong>Device Information:</strong> We may collect
                device-specific information, such as your IP address, device ID,
                operating system, and app version.
              </li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>
              We use the information we collect for the following purposes: to
              improve and personalize your experience with the App, to analyze
              usage and trends to better understand how our App is used, to
              ensure the proper functionality and security of the App.
            </p>

            <h2>3. Third-Party Services</h2>
            <p>We don't use third-party services.</p>

            <h2>4. Data Retention</h2>
            <p>
              We retain data only for as long as necessary to provide you with
              the App's services and improve the App. After this period, we will
              securely delete or anonymize your data.
            </p>

            <h2>5. Data Security</h2>
            <p>
              We take reasonable steps to protect the information we collect from
              loss, theft, misuse, and unauthorized access. However, no method
              of transmission over the internet or method of electronic storage
              is completely secure, and we cannot guarantee absolute security.
            </p>

            <h2>6. Children's Privacy</h2>
            <p>
              Our App is not intended for children under the age of 13, and we
              do not knowingly collect personal information from children. If you
              believe we have inadvertently collected such information, please
              contact us, and we will delete it.
            </p>

            <h2>7. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. When we do, we
              will revise the effective date at the top of this page. We
              encourage you to review this policy periodically to stay informed
              about how we are protecting your information.
            </p>

            <h2>8. Your Rights</h2>
            <p>
              Depending on your location, you may have the right to: request
              access to your data; request correction or deletion of your data;
              opt-out of data collection by uninstalling the App.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or the App,
              please contact us at:{" "}
              <a href="mailto:contact@ygalaad.com" className="privacy-link">
                contact@ygalaad.com
              </a>{" "}
              or at: Ygalaad, 230 Route Des Dollines 06560 VALBONNE
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
